const CHAT_MODAL_SHOW = 'CHAT_MODAL_SHOW';
const CHAT_MODAL_HIDE = 'CHAT_MODAL_HIDE';

const REDUCER_CHAT_MODAL_NAME = 'reducerChatModal';

export {
  CHAT_MODAL_SHOW,
  CHAT_MODAL_HIDE,

  REDUCER_CHAT_MODAL_NAME,
};
